module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_08.16189e6c.jpg";